import * as React from "react";
import DateFilter from "views/components/widgets/overview-configuration/filters/DateFilter";
import AssigneeFilter from "search/overview-configuration/filters/AssigneeFilter";
import Assignee from "search/overview-configuration/Assignee";
import StatusFilter from "./StatusFilter";
import StatusValue from "./StatusValue";
import PriorityFilter from "./PriorityFilter";
import PriorityValue from "./PriorityValue";
const dateFilterComponents = {
  configuration: (_selectedValues, editValue, onChange) => /* @__PURE__ */ React.createElement(DateFilter, { values: editValue, onChange: (newValue) => onChange(newValue, false) }),
  valueForConfig: (values) => values.join(","),
  valueFromConfig: (value) => value ? value.split(",") : [],
  renderValue: (values) => values.replace(",", " to "),
  submitChangesOnClose: true
};
const filterComponents = [
  {
    attribute: "created_at",
    ...dateFilterComponents
  },
  {
    attribute: "updated_at",
    ...dateFilterComponents
  },
  {
    attribute: "assigned_to",
    configuration: (selectedValues, editValue, onChange) => /* @__PURE__ */ React.createElement(
      AssigneeFilter,
      {
        value: editValue,
        selectedAssignees: selectedValues,
        onSelect: (newValue) => onChange(newValue)
      }
    ),
    renderValue: (value) => /* @__PURE__ */ React.createElement(Assignee, { assigneeId: value })
  },
  {
    attribute: "status",
    configuration: (selectedValues, editValue, onChange) => /* @__PURE__ */ React.createElement(StatusFilter, { value: editValue, selectedStatuses: selectedValues, onChange: (newValue) => onChange(newValue) }),
    renderValue: (value) => /* @__PURE__ */ React.createElement(StatusValue, { statusName: value }),
    allowMultipleValues: true
  },
  {
    attribute: "priority",
    configuration: (selectedValues, editValue, onChange) => /* @__PURE__ */ React.createElement(
      PriorityFilter,
      {
        value: editValue,
        selectedPriorities: selectedValues,
        onChange: (newValue) => onChange(newValue)
      }
    ),
    renderValue: (value) => /* @__PURE__ */ React.createElement(PriorityValue, { priorityId: value }),
    allowMultipleValues: true
  }
];
export default filterComponents;
